import gql from 'graphql-tag'

export const serviceCompanyInvitationDelete = gql`
  mutation serviceCompanyInvitationDelete($invitationId: ID!) {
    serviceCompanyInvitationDelete(input: { invitationId: $invitationId }) {
      success
    }
  }
`
